module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('menu', {
    class: ( _obj = {
      'none-border': _vm.$route.name != 'Index'
    }, _obj[_vm.menuClass] = [_vm.menuClass], _obj )
  }, [_c('a', {
    staticClass: "menu-logo",
    attrs: {
      "href": "https://www.championat.com/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$root.gaSend('main', 'click', 'championat')
      }
    }
  }, [_c('logo-app')], 1), _vm._v(" "), (_vm.$route.name != 'Index') ? _c('router-link', {
    staticClass: "back",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$root.gaSend('main', 'click', 'championat')
      }
    }
  }, [_c('span', [_vm._v("\n            Вернуться\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.$root.isMobile && _vm.$route.name == 'Index') ? _c('a', {
    staticClass: "menu-btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stateMenu = !_vm.stateMenu
      }
    }
  }, [(!_vm.stateMenu) ? _c('menu-app', {
    staticClass: "menu-icon"
  }) : _c('menu-close', {
    staticClass: "close-icon"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.$root.isMobile) ? _c('span', {
    staticClass: "menu-disclaimer"
  }, [_vm._v("\n        СПЕЦИАЛЬНЫЙ ПРОЕКТ\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-share"
  }, [_c('div', {
    staticClass: "share-links"
  }, [_c('ul', _vm._l((_vm.shareLinks), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$root.Helpers.share(item.network, _vm.shareUrl(), _vm.toMain()), _vm.$root.gaSend('main', 'click', item.network)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })])])
  }))]), _vm._v(" "), _c('heart-app')], 1)], 1)
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78beb9fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Menu.vue
// module id = 646
// module chunks = 1